module.exports = __webpack_public_path__ + "img/strategy_icon2.176fcbb7-a1adbde5.d4e7610a.svg";